import { render, staticRenderFns } from "./SpaceCalendarSync.vue?vue&type=template&id=5b11d58d&scoped=true"
import script from "./SpaceCalendarSync.vue?vue&type=script&lang=ts"
export * from "./SpaceCalendarSync.vue?vue&type=script&lang=ts"
import style0 from "./SpaceCalendarSync.vue?vue&type=style&index=0&id=5b11d58d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b11d58d",
  null
  
)

export default component.exports